import script from "./MarketIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketIndex.vue?vue&type=script&setup=true&lang=js"

import "./MarketIndex.vue?vue&type=style&index=0&id=f9de840a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9de840a"]])

export default __exports__